import { DateTime } from 'luxon'
const $minusDate = function (date = '', value, opt) {
  const { type = 'days', format = 'yyyy-MM-dd' } = { ...opt }

  const data = {}
  data[type] = value
  return DateTime.fromISO(date).minus(data).toFormat(format)
}

let minusDate = {
  install: (app, options) => {
    app.config.globalProperties.$minusDate = $minusDate
    app.provide('minusDate', $minusDate)
  }
}

export default minusDate
